// Test IDs for the table / QR gate — the screens that decide whether this device
// may order at all. Keys camelCase, values kebab-case (see auth.js).

export const TABLE = {
	scanRequired: 'table-scan-required',
};
